const ON_TIME_CHANGE = "ON_TIME_CHANGE"
const FETCH_WEATHER_PENDING = 'FETCH_WEATHER_PENDING'
const FETCH_WEATHER_SUCCESS = 'FETCH_WEATHER_SUCCESS'
const FETCH_WEATHER_ERROR = 'FETCH_WEATHER_ERROR'
export const FETCH_PLACES_ERROR = 'FETCH_PLACES_ERROR';
export const FETCH_PLACES_SUCCESS = 'FETCH_PLACES_SUCCESS';
export const FETCH_PLACES_PENDING = 'FETCH_PLACES_PENDING';
export const CHANGE_CURRENT_IMAGE = 'CHANGE_CURRENT_IMAGE';
export const ADD_RATING = 'ADD_RATING';

const FETCH_EXCHANGE_PENDING = 'FETCH_EXCHANGE_PENDING'
const FETCH_EXCHANGE_SUCCESS = 'FETCH_EXCHANGE_SUCCESS'
const FETCH_EXCHANGE_ERROR = 'FETCH_EXCHANGE_ERROR'

export {
    ON_TIME_CHANGE, FETCH_WEATHER_PENDING, FETCH_WEATHER_SUCCESS, FETCH_WEATHER_ERROR, FETCH_EXCHANGE_PENDING, FETCH_EXCHANGE_SUCCESS,FETCH_EXCHANGE_ERROR
}
